import { render } from "./LoginScreen.vue?vue&type=template&id=1a5f89a9"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=1a5f89a9&lang=scss"
script.render = render

export default script